module.exports = __webpack_public_path__ + "static/img/hwsq_banner.4ba01ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwsq_banner.png
// module id = P9iH
// module chunks = 21